export default __webpack_public_path__ + "static/banner_back-0ad9843677dbd749343e579b1d75e16d.webp";